<template>
  <div class="footer-navigation" v-click-outside="() => isOpenOtherSubMenu = false">
    <div
      v-for="menu in menus" :key="menu.name"
      :class="['footer-menu', { 'active': currentMenu === menu.name, 'clickable': $route.name !== menu.name }]"
      @click="onClickMenu(menu)"
    >
      <img
        v-if="currentMenu === menu.name"
        :src="require(`@/assets/images/menu_icons/${menu.name}Active.png`)"
        class="img-menu-icon"
      />
      <img
        v-else
        :src="require(`@/assets/images/menu_icons/${menu.name}.png`)"
        class="img-menu-icon"
      />
      <span class="footer-menu-name">{{ $t(`common.menus.${menu.name}`) }}</span>
    </div>
    <div v-if="isOpenOtherSubMenu"
     class="footer-other-sub-menu clickable"
    >
      <div
        v-for="subMenu in subMenus"
        :key="subMenu.name"
        class="footer-other-sub-menu-inner"
      >
        <template>
          <div @click="onClickSubMenu(subMenu.name)">
            <img
              :src="require(`@/assets/images/menu_icons/${subMenu.name}.png`)"
              class="footer-other-sub-menu-inner-icon"
            />
            <span class="footer-other-sub-menu-inner-name">{{ $t(`common.subMenus.${subMenu.name}`) }}</span>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import ClickOutside from 'vue-click-outside'

export default {
  name: 'FooterNavigation',
  directives: {
    ClickOutside
  },
  props: {
    menus: Array,
    currentMenu: String,
    user: Object
  },
  data() {
    return {
      isOpenOtherSubMenu: false,
      subMenus: []
    }
  },
  created () {
    const otherMenu = this.menus.filter(e => {
      return e.name === 'other'
    })
    this.subMenus = otherMenu[0].subMenus
  },
  methods: {
    onClickMenu: function(menu) {
      if (menu.name === 'other') {
        this.isOpenOtherSubMenu = !this.isOpenOtherSubMenu
      } else {
        this.isOpenOtherSubMenu = false
        this.$emit('onClickNextMenu', menu.name)
      }
    },
    onClickSubMenu: function(menu) {
      this.isOpenOtherSubMenu = false
      switch (menu) {
        case 'myPage':
          this.$emit('onClickMyPage')
          break
        case 'changeOrganization':
          this.$emit('onClickChangeOrganization')
          break
        case 'signOut':
          this.$emit('onClickSignOut')
          break
        default: {
          this.$emit('onClickNextMenu', menu)
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/styles/variables";

.footer-navigation {
  z-index: 1000;
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 54px;
  padding: 8px 12px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  background-color: white;
  box-shadow: 0px 0px 4px #00000026;

  .footer-menu {
    text-align: center;
    word-break: keep-all;

    &.active .footer-menu-name {
      color: $primary-color;
    }
  }

  .footer-menu-name {
    display: block;
    font-size: 9px;
    font-weight: 600;
    margin-top: 5px;
    color: $light-text-color;
  }

  .footer-other-sub-menu {
    position: absolute;
    right: 20px;
    bottom: 45px;
    color: $light-text-color;
    background-color: white;
    border-radius: 6px;
    box-shadow: 0px 0px 4px #00000026;
    width: 170px;

    &-inner {
      border-bottom: 1px solid $light-border-color;
      padding: 15px 0;

      &-icon {
        margin-right: 10px;
        margin-left: 20px;
        width: 20px;
        height: 20px;
      }

      &-name {
        font-size: 13px;
        font-weight: 600;
      }

      button {
        font-size: 13px !important;
        color: $light-text-color !important;
        border: 1px solid $dark-border-color !important;
        padding: 8px 0;
        border-radius: 4px;
        width: 120px;
        margin: 0 auto;

        &:hover {
          background-color: $background-color !important;
        }
      }
    }
  }
}
</style>
